import { MyEquipmentFooterNote } from "components/pcc-components"
import { useTranslations } from "next-intl"
import styles from './style.module.scss'


export const AddEquipmentFootNote = () => {
  const t = useTranslations()
  return (
    <div
      className={`${styles['warning-message-box']} d-flex col-12 mt-2 px-0 position-absolute`}
    >
      <MyEquipmentFooterNote>{t('MEQ_WARNING_MESSAGE')}</MyEquipmentFooterNote>
    </div>
  );
}